import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Dialog,
  DialogTitle,
  DialogActions,
} from "@mui/material";
import { Done as DoneIcon, Close as CloseIcon } from "@mui/icons-material";
import "./OfficialDocs.css";
import DualBall from "../../../utilities/dual ball back.svg";
import { Button } from "react-bootstrap";

const OfficialDocs = (props) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [loader, showLoader] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const Employee = props.Employee;
  const user = props.user;

  const fetchDocuments = async () => {
    try {
      const response = await fetch(
        `https://hr-backend-72v1.onrender.com/documents?email=${Employee.email}`
      );
      const data = await response.json();

      if (Array.isArray(data)) {
        const filteredDocuments = data.filter(
          (doc) => doc.status === "Pending" || doc.status === "Accepted"
        );
        const sortedDocuments = filteredDocuments.sort((a, b) => {
          if (a.status === "Pending" && b.status === "Accepted") return -1;
          if (a.status === "Accepted" && b.status === "Pending") return 1;
          return 0;
        });

        setDocuments(sortedDocuments);
      } else {
        console.error("Unexpected response format:", data);
      }
    } catch (error) {
      console.error("Error fetching documents:");
    }
  };

  useEffect(() => {
    fetchDocuments();
  }, [Employee]);

  const onFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const onFileUpload = async () => {
    showLoader(true);
    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("name", Employee.name);
    formData.append("email", (Employee.role === "HR" || Employee.role === "Executive") ? "hr@growthguild.us" : Employee.email);
    try {
      const response = await fetch("https://hr-backend-72v1.onrender.com/upload", {
        method: "POST",
        body: formData,
      });

      await response.json();
      showLoader(false);

      fetchDocuments();
    } catch (error) {
      console.error("Error:");
      showLoader(false);
    }
  };
  const handleDelete = async (documentId) => {
    try {
      const res = await fetch(`https://hr-backend-72v1.onrender.com/delete/${documentId}`, {
        method: "DELETE",
      });

      const data = await res.json();
      if (res.ok) {
        alert("Document deleted successfully");
        fetchDocuments();
      } else {
        alert(`Error: ${data.message}`);
      }
    } catch (error) {
      console.error("Error deleting document:", error);
      alert("Something went wrong while deleting.");
    }
  };

  const handleDownload = async (doc) => {
    try {
      const response = await fetch(
        `https://hr-backend-72v1.onrender.com/documents/${doc._id}/download`
      );
      if (!response.ok) throw new Error("Download failed");

      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = objectUrl;
      a.download = doc.fileName || "document";
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(objectUrl);
    } catch (error) {
      console.error("Error downloading document:", error);
      alert("Could not download the file. Please try again.");
    }
  };

  const confirmDelete = (id) => {
    setDeleteId(id);
    setConfirmOpen(true);
  };

  const handleConfirm = () => {
    handleDelete(deleteId);
    setConfirmOpen(false);
  };

  return (
    <div className="documents-container">
      <div className="docs-head">
        <h2 className="heading-xx-large">Official Documents</h2>
        <div className="upload-btn" style={{ marginRight: "20px" }}>
          <input
            id="file-upload"
            type="file"
            onChange={onFileChange}
            disabled={loader}
          />
          <button
            className="upload-button"
            onClick={onFileUpload}
            disabled={loader || !selectedFile}
          >
            Upload!
          </button>
          {loader && (
            <img
              className="dual-ball"
              src={DualBall}
              alt="Dual Ball"
              width="70"
              height="70"
            />
          )}
        </div>
      </div>
      <hr />
      <TableContainer component={Paper} sx={{ width: "95%", margin: "auto" }}>
        <Table aria-label="documents table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontSize: "20px" }}>
                <strong>Document</strong>
              </TableCell>
              <TableCell sx={{ fontSize: "20px" }}>
                <strong>Uploaded Date</strong>
              </TableCell>
              <TableCell sx={{ fontSize: "20px" }}>
                <strong>Status</strong>
              </TableCell>
              {(user.role === "HR" || user.role === "Executive") && (
                <TableCell sx={{ fontSize: "20px" }}>
                  <strong>Action</strong>
                </TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {documents.length === 0 ? (
              <h2 className="heading-xx-large" style={{ margin: "30px" }}>
                🫥 Quiet and empty.
              </h2>
            ) : (
              documents.map((doc) => (
                <TableRow key={doc._id}>
                  <TableCell>
                    <button
                      onClick={() => handleDownload(doc)}
                      className="upload-button"
                    >
                      {doc.fileName}
                    </button>
                  </TableCell>
                  <TableCell>
                    {new Date(doc.uploadTime).toLocaleString()}
                  </TableCell>
                  <TableCell> {doc.status}</TableCell>

                  {(user.role === "HR" || user.role === "Executive") && (
                    <TableCell>
                      <IconButton
                        onClick={() => confirmDelete(doc._id)}
                        color="error"
                      >
                        <CloseIcon />
                      </IconButton>
                    </TableCell>
                  )}
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)}>Cancel</Button>
          <Button onClick={handleConfirm} color="error">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default OfficialDocs;
